/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BackInputs */

const th_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับ`)
};

const en_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const ja_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const zh_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const es_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrás`)
};

const pt_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const id_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali`)
};

const fr_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const tl_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bumalik`)
};

const vi_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại`)
};

const ko_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤로`)
};

const de_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const ru_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const tr_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri`)
};

const it_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

const pl_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstecz`)
};

const uk_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const hi_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वापस`)
};

const ar_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجوع`)
};

const ms_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali`)
};

const bn_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিরে যান`)
};

const zh_tw2_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const zh_hk2_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const ur_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واپس`)
};

const fa_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازگشت`)
};

const sw_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rudi`)
};

const nl_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {BackInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const back = /** @type {((inputs?: BackInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BackInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_back(inputs)
	if (locale === "ja") return ja_back(inputs)
	if (locale === "zh") return zh_back(inputs)
	if (locale === "es") return es_back(inputs)
	if (locale === "pt") return pt_back(inputs)
	if (locale === "id") return id_back(inputs)
	if (locale === "fr") return fr_back(inputs)
	if (locale === "tl") return tl_back(inputs)
	if (locale === "vi") return vi_back(inputs)
	if (locale === "ko") return ko_back(inputs)
	if (locale === "de") return de_back(inputs)
	if (locale === "ru") return ru_back(inputs)
	if (locale === "tr") return tr_back(inputs)
	if (locale === "it") return it_back(inputs)
	if (locale === "pl") return pl_back(inputs)
	if (locale === "uk") return uk_back(inputs)
	if (locale === "hi") return hi_back(inputs)
	if (locale === "ar") return ar_back(inputs)
	if (locale === "ms") return ms_back(inputs)
	if (locale === "bn") return bn_back(inputs)
	if (locale === "zh-TW") return zh_tw2_back(inputs)
	if (locale === "zh-HK") return zh_hk2_back(inputs)
	if (locale === "ur") return ur_back(inputs)
	if (locale === "fa") return fa_back(inputs)
	if (locale === "sw") return sw_back(inputs)
	if (locale === "nl") return nl_back(inputs)
	return en_back(inputs)
});